const SessionTypeReference = `
  fragment SessionTypeReference on SessionTypeReference {
    label
    value
  }
`
export default SessionTypeReference
